module.exports = __webpack_public_path__ + "media/images/iconBell__inactive--dark-d75eefb882666f947d30f1124255e881.png";